import { render } from "./CustomizerStepShell.vue?vue&type=template&id=58ca62af&scoped=true"
import script from "./CustomizerStepShell.vue?vue&type=script&lang=js"
export * from "./CustomizerStepShell.vue?vue&type=script&lang=js"

import "./CustomizerStepShell.vue?vue&type=style&index=0&id=58ca62af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ca62af"]])

export default __exports__